import { createContext, useContext, useMemo, useReducer } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { photoPlaceholderBase64 } from "./constants";
// The DigitalPass main context
const DigitalPass = createContext();

// Setting custom name for the context which is visible on react dev tools
DigitalPass.displayName = "DigitalPassContext";
// DigitalPass reducer
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "SET_COMPANY_DETAILS": {
      return { ...state, companyDetails: action.value };
    }
    case "SET_USER": {
      return { ...state, userDetails: action.value };
    }
    case "SET_USERTYPE": {
      return { ...state, usertype: action.value };
    }
    case "SET_SESSION": {
      return { ...state, session: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// DigitalPass context provider
function DigitalPassControllerProvider({ children }) {
  const initialState = {
    miniSidenav: false,
    whiteSidenav: true,
    sidenavColor: "info",
    transparentNavbar: true,
    fixedNavbar: true,
    layout: "page",
    companyDetails: JSON.parse(localStorage.getItem("company")),
    userDetails: JSON.parse(localStorage.getItem("user")),
    session: localStorage.getItem("session"),
    usertype: parseInt(localStorage.getItem("usertype")),
    photoPlaceholderBase64: photoPlaceholderBase64,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);
  return <DigitalPass.Provider value={value}>{children}</DigitalPass.Provider>;
}

// DigitalPass custom hook for using context
function useDigitalPassController() {
  const context = useContext(DigitalPass);

  if (!context) {
    throw new Error(
      "useDigitalPassController should be used inside the DigitalPassControllerProvider."
    );
  }
  return context;
}
// Typechecking props for the DigitalPassControllerProvider
DigitalPassControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setCompanyDetails = (dispatch, value) => dispatch({ type: "SET_COMPANY_DETAILS", value });
const setUserDetails = (dispatch, value) => dispatch({ type: "SET_USER", value });
const setUserType = (dispatch, value) => dispatch({ type: "SET_USERTYPE", value });
const setSession = (dispatch, value) => dispatch({ type: "SET_SESSION", value });

export {
  DigitalPassControllerProvider,
  useDigitalPassController,
  setMiniSidenav,
  setTransparentNavbar,
  setFixedNavbar,
  setLayout,
  setCompanyDetails,
  setUserDetails,
  setUserType,
  setSession,
};
